import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";
import type { AxialLoadsPolar } from "@/pages/admin/compositeJob/components/Checks/sub/AxialLoadsChecks";

export type ExcludeComponentStrengthPolar = {
  do_you_want_to_completely_exclude_the_components_strength_for_design: PolarYesNoUndefined;
  do_you_want_to_take_into_account_any_additional_forces_and_moments: PolarYesNoUndefined;
};
type ExcludeComponentStrenthProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof ExcludeComponentStrengthPolar }) => void;
  polarQuestions: ExcludeComponentStrengthPolar;
  axialLoadsQuestions: AxialLoadsPolar;
};
export default function ExcludeComponentStrengthChecks({
  onHandleYesNo,
  polarQuestions,
  axialLoadsQuestions,
}: ExcludeComponentStrenthProps) {
  return (
    <>
      <PolarQuestion
        shouldRender={true}
        question="Do you want to completely exclude the components strength for design?(not standard and results in most layers)"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "do_you_want_to_completely_exclude_the_components_strength_for_design" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "do_you_want_to_completely_exclude_the_components_strength_for_design" });
        }}
        selection={polarQuestions.do_you_want_to_completely_exclude_the_components_strength_for_design}
      />
      {axialLoadsQuestions.is_component_straight_line !== "yes" &&
        polarQuestions.do_you_want_to_completely_exclude_the_components_strength_for_design === "yes" && (
          <PolarQuestion
            shouldRender={polarQuestions.do_you_want_to_completely_exclude_the_components_strength_for_design === "yes"}
            question="Do you want to take into account any additional forces and moments?(consult enginnering if unsure)"
            onNoClick={() => {
              onHandleYesNo({ value: "no", key: "do_you_want_to_take_into_account_any_additional_forces_and_moments" });
            }}
            onYesClick={() => {
              onHandleYesNo({
                value: "yes",
                key: "do_you_want_to_take_into_account_any_additional_forces_and_moments",
              });
            }}
            selection={polarQuestions.do_you_want_to_take_into_account_any_additional_forces_and_moments}
          />
        )}
    </>
  );
}
